module.exports = __webpack_public_path__ + "static/media/uxd.0fad4a67.png";